import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LMChartBase } from './lm-chart-base';
import { SohoBarComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-chart-bar',
  template: `
    <div soho-bar
        [dataset]="dataset"
        [redrawOnResize]="true"
        [showLegend]="showLegend"
        [emptyMessage]="{title: 'No Data Available', info: 'No Data Available', icon: 'icon-empty-no-data'}"
        [type]="type"
        [isStacked]="isStacked"
        [isNormalized]="isNormalized"
        [isGrouped]="isGrouped"
        [animate]="animate"
        [tooltip]="tooltip"

        (selected)="onSelected($event)"
        (rendered)="onRendered($event)"
        (unselected)="onUnselected($event)"
        (contextmenu)="onContextMenu($event)"
    ></div>

    <!-- FOR bar CHART formatterString(value: string)  format(value: string)  tooltip(value: string)  useLogScale(value: boolean)
ticks(value: object[])  showLines(value: boolean)  labelFactor(value: number)  wrapWidth(value: number)
-->
  `
})
export class LMChartBarComponent extends LMChartBase {
  @ViewChild(SohoBarComponent, { static: true }) sohoBarComponent: SohoBarComponent;

  @Input() isStacked: boolean;
  @Input() isNormalized: boolean;
  @Input() isGrouped: boolean;

  constructor(
    public elementRef: ElementRef,
  ) {
    super(elementRef);
  }

  public getChartComponent() {
    return this.sohoBarComponent;
  }
}
